// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cbb5d370","453":"836f537b","732":"01f65f33"}[chunkId] + ".chunk.js";
};